import { Injectable } from '@angular/core';
import { FunctionHelper } from '@app/utils/helpers/functionHelper';
import { ApiClientService } from '@app/core/http/api-client.service';

const PATH = 'client/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private apiClient: ApiClientService,
    private functionHelper: FunctionHelper,
  ) { }

  async update(content: any) {
    return await this.apiClient.post(`${PATH}/update/data`, JSON.stringify(content));
  }

  async completeProfile(content: { document?: string; birthdate?: string; gender?: 'man' | 'woman' | 'others' | 'nops' }) {
    const response = await this.apiClient.post(
      `${PATH}/update/complete-profile`,
      JSON.stringify(content),
    );
    return this.unwrapData(response);
  }

  async generateCode(content: any) {
    return await this.apiClient.post(`${PATH}/get-access-token`, JSON.stringify(content));
  }

  async updateAvatar(content: any) {
    content = this.functionHelper.convertToFormData(content);

    return await this.apiClient.post(`${PATH}/update/avatar`, content, 'authMultiPart');
  }

  async updatePassword(content: any) {
    return await this.apiClient.post(`${PATH}/update/password`, JSON.stringify(content));
  }

  async updateSettings(content: any) {
    return await this.apiClient.post(`${PATH}/update/settings`, JSON.stringify(content));
  }

  async requestEmailVerification() {
    const response = await this.apiClient.post(
      `${PATH}/email/request-verification`,
      JSON.stringify({}),
    );
    return this.unwrapData(response);
  }

  async verifyEmail(accessCode: string) {
    const response = await this.apiClient.post(
      `${PATH}/email/verify`,
      JSON.stringify({ access_code: accessCode }),
    );
    return this.unwrapData(response);
  }

  async requestEmailChange(newEmail: string) {
    const response = await this.apiClient.post(
      `${PATH}/email/change-request`,
      JSON.stringify({ new_email: newEmail }),
    );
    return this.unwrapData(response);
  }

  async confirmEmailChange(newEmail: string, accessCode: string) {
    const response = await this.apiClient.post(
      `${PATH}/email/change-confirm`,
      JSON.stringify({ new_email: newEmail, access_code: accessCode }),
    );
    return this.unwrapData(response);
  }

  async refresh() {
    const response = await this.apiClient.get('auth/refresh', 'authRefresh');

    return this.unwrapData(response);
  }

  async logout() {
    return await this.apiClient.get(`${PATH}/logout`);
  }

  async googleCalendarLogin(googleToken: any) {
    const content = {
      google_token: googleToken.code
    };

    return await this.apiClient.post(`${PATH}/google-calendar/login`, JSON.stringify(content));
  }

  async googleCalendarLogout() {
    return await this.apiClient.post(`${PATH}/google-calendar/logout`);
  }

  private unwrapData(response: any) {
    return response?.data ?? response;
  }
}
